define(function(require){
	'use strict';

	var Marionette = require('marionette');
	var LPTModel   = require('vendor/Backbone/LPTModel');

	var AppConfig       = require('config/application');
	/*
	*	Site model
	*/
	return LPTModel.extend({
		/*
		*	function urlRoot()
		*	Get sync url
		*	@return {string} url
		*/
		urlRoot: function(){
			return AppConfig.host + '/rest/sites';
		},

		/*
		*	function toggleShow()
		*	Toggle showing site in staff
		*/
		toggleShow: function(){
			this.set('_session_is_show', !this.get('_session_is_show'));
		},

		/*
		* for validation
		*/
		defaults : {
			name : '',
			page : '',

		},
		validation : {
			name : {
				required 	: true ,
				minLength   : 1 ,
			}
		}
	});
});
